import { price as priceUtil } from '@eti/utils';
import { Inline, Stack, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { useSeatCharacteristicMeta } from '../hooks/useSeatCharacteristicMeta';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  icon: css`
    height: 24px;
    width: 24px;
  `,
  priceDescription: css`
    width: 75%;
  `,
  wrapper: css`
    width: 100%;
  `
};
const SeatCharacteristicsToggleContent = _ref => {
  let {
    characteristic,
    isUnavailable,
    priceFrom
  } = _ref;
  const {
    iconUrl,
    label,
    description,
    priceFromLabel
  } = useSeatCharacteristicMeta(characteristic, isUnavailable);
  return /*#__PURE__*/_jsxs(Inline, {
    align: "start",
    className: styles.wrapper,
    children: [iconUrl && /*#__PURE__*/_jsx("img", {
      alt: "",
      className: styles.icon,
      src: iconUrl
    }), /*#__PURE__*/_jsxs(Stack, {
      className: styles.priceDescription,
      spacing: 4,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: textVariants._14_BOLD,
        children: label
      }), !isUnavailable && priceFrom !== undefined && /*#__PURE__*/_jsxs(Text, {
        variant: textVariants._14,
        children: [priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
      }), /*#__PURE__*/_jsx(Text, {
        variant: textVariants._14,
        children: description
      })]
    })]
  });
};
export default SeatCharacteristicsToggleContent;
//# sourceMappingURL=SeatCharacteristicsToggleContent.js.map